export default {
  newPreset: 'Neue Voreinstellung',
};
